import { InputField, type InputFieldProps } from "./InputField";

/**
 * Formats SSN input to only allow digits
 * Prevents letters, dashes, and other special characters
 */
export const formatSSN = (text: string): string => {
  // Only allow digits
  return text.replace(/[^0-9]/g, "");
};

/**
 * Formats SSN Last 4 input to only allow digits
 */
export const formatSSNLast4 = (text: string): string => {
  // Only allow digits
  return text.replace(/[^0-9]/g, "");
};

/**
 * Full SSN field (9 digits)
 * Only allows digits, max 9 characters
 */
export const SSNField = (props: InputFieldProps) => {
  return <InputField formatInput={formatSSN} inputMode="numeric" keyboardType="number-pad" maxLength={9} {...props} data-sentry-element="InputField" data-sentry-component="SSNField" data-sentry-source-file="SSNField.tsx" />;
};

/**
 * SSN Last 4 field (XXXX format)
 * Only allows digits, max 4 characters
 */
export const SSNLast4Field = (props: InputFieldProps) => {
  return <InputField formatInput={formatSSNLast4} inputMode="numeric" keyboardType="number-pad" maxLength={4} {...props} data-sentry-element="InputField" data-sentry-component="SSNLast4Field" data-sentry-source-file="SSNField.tsx" />;
};